<template>
  <vue-modal
    :modal-title="$t('pages.profile.tabs.personal_data.general')"
    :show-spinner="isLoading"
    :show-modal="showModal"
    :modalLarge="true"
    :loading-primary-footer-button="isLoading"
    :showSecondaryFooterButton="false"
    @[primaryEvent]="onPrimaryButtonClicked"
    @[closeEvent]="onCloseButtonClicked"
  >
    <template #body>
      <div class="profile">
        <article>
          <form>
            <div class="alert alert-danger" role="alert" v-if="error">
              {{ error }}
            </div>
            <div class="row">
              <div class="col-md-6">
                <employee-name-field
                  id="edit-employee-name"
                  name="name"
                  :form="form"
                  v-if="canEditName"
                />

                <employee-first-family-name-field
                  id="edit-employee-first-family-name"
                  name="firstFamilyName"
                  :form="form"
                  v-if="canEditFirstName"
                />
                <employee-second-family-name-field
                  id="edit-employee-second-family-name"
                  name="secondFamilyName"
                  :form="form"
                  v-if="canEditSecondName"
                />
              </div>
              <div class="col-md-6">
                <employee-phone-no-2-field
                  id="edit-employee-phone-no-2"
                  name="phoneNo2"
                  :form="form"
                  v-if="canEditEmployeeCompanyPhone"
                />
                <employee-company-email-field
                  id="edit-employee-company-email"
                  name="companyEmail"
                  :form="form"
                  v-if="canEditEmail"
                />
              </div>
            </div>
          </form>
        </article>
      </div>
    </template>
  </vue-modal>
</template>

<script>
import VueModal, {
  CLOSE_BUTTON_CLICKED_MODAL_EVENT,
  PRIMARY_BUTTON_CLICKED_MODAL_EVENT,
  SECONDARY_BUTTON_CLICKED_MODAL_EVENT,
} from "@/components/modal";
import { SHOW_GENERAL_EDIT_FORM_EVENT, PROFILE_DATA_UPDATED_EVENT } from "./index";

import {
  EmployeeNameField,
  EmployeeFirstFamilyNameField,
  EmployeeSecondFamilyNameField,
  EmployeePhoneNo2Field,
  EmployeeCompanyEmailField,
} from "./fields";
import { Form } from "@/components/form";

import { mapGetters } from "vuex";
import * as Sentry from "@sentry/vue";

import api from "@/api/user";
import { RequiredRule, EmailRule } from "@/components/form/data/rules";

export default {
  components: {
    VueModal,
    EmployeeNameField,
    EmployeeFirstFamilyNameField,
    EmployeeSecondFamilyNameField,
    EmployeePhoneNo2Field,
    EmployeeCompanyEmailField,
  },
  data() {
    return {
      isLoading: false,
      showModal: false,
      postedNumber: "",
      options: {
        penColor: "#c0f",
      },
      userData: {},
      error: null,
      form: new Form({
        data: {
          key: null,
          name: null,
          firstFamilyName: null,
          secondFamilyName: null,
          phoneNo2: null,
          companyEmail: null,
        },
      }),
    };
  },
  computed: {
    ...mapGetters("auth", [
      "canEditName",
      "canEditFirstName",
      "canEditSecondName",
      "canEditGender",
      "canEditEmployeeCompanyPhone",
      "canEditEmail",
    ]),
    primaryEvent() {
      return PRIMARY_BUTTON_CLICKED_MODAL_EVENT;
    },
    secondaryEvent() {
      return SECONDARY_BUTTON_CLICKED_MODAL_EVENT;
    },
    closeEvent() {
      return CLOSE_BUTTON_CLICKED_MODAL_EVENT;
    },
    fieldsRules() {
      let rules = [];

      if (this.canEditName) {
        rules.push(
          new RequiredRule({
            name: "name",
            errorMessage: this.$t("components.fields.rules.required"),
          })
        );
      }

      if (this.canEditFirstName) {
        rules.push(
          new RequiredRule({
            name: "firstFamilyName",
            errorMessage: this.$t("components.fields.rules.required"),
          })
        );
      }

      if (this.canEditEmail) {
        rules.push(
          new EmailRule({
            name: "companyEmail",
            errorMessage: this.$t("components.fields.rules.emailWrong"),
            optional: true,
          })
        );
      }

      return rules;
    },
  },

  created() {
    EventBus.listen(SHOW_GENERAL_EDIT_FORM_EVENT, ({ data }) => {
      this.clear();
      this.form.fill(data);
      this.showModal = true;
    });
  },
  beforeDestroy() {
    EventBus.off([SHOW_GENERAL_EDIT_FORM_EVENT]);
  },
  methods: {
    async onPrimaryButtonClicked() {
      this.form.setFieldsRules(this.fieldsRules);
      if (this.form.validate()) {
        try {
          this.isLoading = true;

          await api.myProfileGeneralUpdate(this.form.data());
          EventBus.fire(PROFILE_DATA_UPDATED_EVENT);

          this.$toasts.success(this.$t("components.messages.success"));

          this.showModal = false;
        } catch (error) {
          Sentry.captureException(error);
          this.error = this.$t("components.messages.error");
          console.error(error);
        }
        this.isLoading = false;
      }
    },
    onSecondaryButtonClicked() {
      this.clear();
    },
    onCloseButtonClicked() {
      this.showModal = false;
    },
    clear() {
      this.error = null;
    },
  },
};
</script>

<style scoped></style>
